<div class="modal-content m-0">
  <div class="modal-header">
    <p class="modal-title">{{ 'sample.search.resultTitle' | translate }}</p>
    <i class="fa-light fa-xmark ms-auto cursor-pointer" (click)="dismiss()"></i>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-12">
        <app-data-table
          [configuration]="dataTableConfiguration"
          [loading]="isLoading"
        ></app-data-table>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <div class="row">
      <div class="col-12 d-flex flex-row-reverse">
        <button
          ngbAutoFocus
          type="button"
          class="btn btn-clear"
          (click)="dismiss()"
        >
          {{ 'common.buttons.btnClose' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
